'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Description;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RenderIf = require('./../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Description(_ref) {
  var description = _ref.description,
      isExpanded = _ref.isExpanded;

  var getClassNames = function getClassNames() {
    return (0, _classnames2["default"])('rainbow-vertical-section-overflow_action-description', {
      'rainbow-vertical-section-overflow_action-description--expanded': isExpanded
    });
  };

  return _react2["default"].createElement(_RenderIf2["default"], {
    isTrue: !!description
  }, _react2["default"].createElement('span', {
    className: getClassNames()
  }, description));
}

Description.propTypes = {
  description: _propTypes2["default"].node,
  isExpanded: _propTypes2["default"].bool.isRequired
};
Description.defaultProps = {
  description: ''
};